const setting_public_login_router = dsf.config.setting_public_login_router ?? [
  {
    path: "/pc/login",
    title: "登录",
    loginTitle: "用户登录",
  },
  {
    path: "/pc/respondents/login",
    title: "登录",
    showForgotPassword: false,
    loginTitle: "欢迎登录统计云平台",
  },
  {
    path: "/pc/survey/assistant/login",
    title: "登录",
    showForgotPassword: false,
    loginTitle: "欢迎登录统计云平台",
  },
  {
    path: "/pc/internetLogin",
    title: "登录",
    loginTitle: "用户登录",
  },
];

const routes = [
  {
    path: "/pc/leaderCockpit",
    meta: {
      title: "领导驾舱",
      needLogin: true,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "leaderCockpit" */ "../views/leaderCockpit/LeaderCockpit.vue"
      ),
  },
  {
    path: "/pc/normaluser",
    meta: {
      title: "普通门户",
      needLogin: true,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "normaluser" */ "../views/normalUser/NormalUser.vue"
      ),
  },
  {
    path: "/pc/speciallyuser",
    meta: {
      title: "专业门户",
      needLogin: true,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "speciallyuser" */ "../views/speciallyUser/SpeciallyUser.vue"
      ),
  },
  {
    path: "/pc/institutional-design",
    meta: {
      title: "制度设计",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "institutional-design" */ "../views/institutionalDesign/index.vue"
      ),
  },
  {
    path: "/pc/many-links",
    meta: {
      title: "多环节",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "many-links" */ "../views/manyLinks/index.vue"
      ),
  },
  {
    path: "/pc/managePlatfromHome",
    meta: {
      title: "应用管理平台首页",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "managePlatfromHome" */ "../views/managePlatfromHome/index.vue"
      ),
  },
  {
    path: "/pc/userCenterHome",
    meta: {
      title: "用户中心首页",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "userCenterHome" */ "../views/userCenterHome/index.vue"
      ),
  },
  {
    path: "/pc/appCenterHome",
    meta: {
      title: "应用中心首页",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "appCenterHome" */ "../views/appCenterHome/index.vue"
      ),
  },
  {
    path: "/pc/smartCenterHome",
    meta: {
      title: "智能中心首页",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "smartCenterHome" */ "../views/smartCenterHome/index.vue"
      ),
  },
  {
    path: "/pc/operationCenterHome",
    meta: {
      title: "运营中心首页",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "operationCenterHome" */ "../views/operationCenterHome/index.vue"
      ),
  },
  {
    path: "/pc/infoCenterHome",
    meta: {
      title: "信息中心首页",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "infoCenterHome" */ "../views/infoCenterHome/index.vue"
      ),
  },
  {
    path: "/pc/resourceCenterHome",
    meta: {
      title: "资源中心首页",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "resourceCenterHome" */ "../views/resourceCenterHome/index.vue"
      ),
  },
  {
    path: "/pc/lanPlatformHome",
    meta: {
      title: "内网工作台首页",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "lanPlatformHome" */ "../views/lanPlatformHome/index.vue"
      ),
  },
  {
    path: "/pc/appManageHome",
    meta: {
      title: "应用管理首页",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "appManageHome" */ "../views/appManageHome/index.vue"
      ),
  },
  {
    path: "/pc/userCenterHome2",
    meta: {
      title: "用户中心首页2",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "userCenterHome2" */ "../views/userCenterHome2/index.vue"
      ),
  },
  {
    path: "/pc/uml/interaction",
    meta: {
      title: "运行中心",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "interaction" */ "../views/uml/Interaction.vue"
      ),
  },
  {
    path: "/pc/asqAndWiki",
    meta: {
      title: "问卷和知识库资源",
      needLogin: true,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "asqAndWiki" */ "../views/asqAndWiki/index.vue"
      ),
  },
];

const loginMap = {
  "/pc/login": {
    path: "/pc/login",
    meta: {
      title: "登录",
      needLogin: false,
      waterMark: false,
    },
    // component: Login,
    component: () =>
    import(/* webpackChunkName: "coomonLogin" */ "../views/login1/index"),
    // import(/* webpackChunkName: "internetLogin" */ "../views/internetLogin/login"),
  },
  "/pc/respondents/login": {
    path: "/pc/respondents/login",
    meta: {
      title: "登录",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "RespondentsLogin" */ "../views/respondentsLogin/login.vue"
      ),
  },
  "/pc/survey/assistant/login": {
    path: "/pc/survey/assistant/login",
    meta: {
      title: "登录",
      needLogin: false,
      waterMark: false,
    },
    // component: surveyAssistantLogin,
    component: () =>
      import(
        /* webpackChunkName: "assistantLogin" */ "../views/surveyAssistantLogin/login.vue"
      ),
  },
  "/pc/internetLogin": {
    path: "/pc/internetLogin",
    meta: {
      title: "登录",
      needLogin: false,
      waterMark: false,
    },
    component: () =>
    import(/* webpackChunkName: "NetcomOfficeLogin" */ "../views/login1/NetcomOfficeLogin"),
      // import(
      //   /* webpackChunkName: "internetLogin" */ "../views/internetLogin/login"
      // ),
  },
};

setting_public_login_router?.forEach(({ title, path, loginTitle }) => {
  if (loginMap[path]) {
    loginMap[path].meta.name = title || "登录";
    loginMap[path].meta.loginTitle = loginTitle;
    routes.push(loginMap[path]);
  }
});

// let router = [];

export default routes;